import { render } from "./recruit.vue?vue&type=template&id=2933aabc&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"

import "./recruit.vue?vue&type=style&index=0&id=2933aabc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\zhuxu\\source\\repos\\innosource\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2933aabc"]])

export default __exports__